import React, { useState } from "react";
import "./newAccount.scss";
import Close from "@mui/icons-material/Close";
import {
  ManageAccounts,
  VisibilityOff,
  VisibilityOutlined,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

import toast, { LoaderIcon } from "react-hot-toast";
import { PersonnelType, requestType } from "../../../../types/GlobalType";
import { accountService } from "../../../../_services/accountServices";
import user_api from "../../../../apiCaller/user.Caller";
import { catchErrorApiCall } from "../../../../_services/apiUtils";
import ErrorBar from "../../../../component/errorComp/ErrorBar.tsx";

type Props = {
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setOpen2: React.Dispatch<React.SetStateAction<Boolean>>;
  data: PersonnelType;
  dispatchReload: () => void;
};
const NewAccount = (props: Props) => {
  const [email, setEmail] = useState<string>("");
  const [pswd, setpswd] = useState<string>("");
  const [errorMsg, setError] = useState<string>("");
  const [visible, setVisible] = useState<boolean>(false);
  const [type, setType] = useState<string>("password");
  const [state, setState] = React.useState<requestType>({
    isLoading: false,
    errorMessage: null,
  });

  const navigate = useNavigate();

  const handleCreate = async () => {
    if (!pswd?.toString().length || !email.toString().length) {
      return setState({
        ...state,
        errorMessage: "Veuiller compléter tous les champs",
      });
    }

    setState({ isLoading: true, errorMessage: null, successMessage: null });

    let token = accountService.getToken();
    if (!token) return navigate("/login");

    let userId = accountService.getUserImei();
    if (!userId) return navigate("/login");

    try {
      let data = {
        personnel_id: props.data.personnel_id,
        email,
        password: pswd,
      };
      const response = await user_api.create(data, token);
      if (response.data.status === 200 || response.data.status === 201) {
        toast.success("Création effectuée avec succes", {
          duration: 4000,
          style: {
            zIndex: 9999,
          },
        });
        setpswd("");
        props.dispatchReload();
        props.setOpen(false);
        props.setOpen2(false);
      } else {
        toast.error("Une erreur s'est produite, réesayez plus tard", {
          style: {
            backgroundColor: "#630f0f", // Custom background color
            color: "white", // Text color
            fontSize: "12px", // Font size
            zIndex: 9999,
          },
        });
      }
    } catch (error) {
      if (error.response.data.status === 401) {
        props.setOpen(false);
        props.setOpen2(false);
        return toast.error("Cette adresse mail existe déja", {
          duration: 6000,
          style: {
            backgroundColor: "#630f0f", // Custom background color
            color: "white", // Text color
            fontSize: "12px", // Font size
            zIndex: 99999,
          },
        });
      }
      catchErrorApiCall(error);
    } finally {
      setState({ ...state, isLoading: false });
    }
  };

  return (
    <>
      {/* <MyLoading isLoading={state.isLoading} /> */}
      <div className="update_pswd">
        <div className="dialogP">
          <div className="header_pswd">
            <div className="header_left">
              <ManageAccounts />
              {"Nouveau compte"}
            </div>
            {state.isLoading ? (
              <Close className="ico_close" />
            ) : (
              <Close
                className="ico_close"
                onClick={() => props.setOpen(false)}
              />
            )}
          </div>
          {!!errorMsg && <ErrorBar title={errorMsg} />}
          <div className="body">
            {state.errorMessage && <ErrorBar title={state.errorMessage} />}
            <div className="itemsP">
              <div className="itemP">
                <span>Email *</span>
                <div className="email">
                  <input
                    type="text"
                    placeholder={"Adresse mail"}
                    onChange={(e) => setEmail(e.target.value)}
                    value={email}
                  />
                </div>
              </div>

              <div className="itemP">
                <span>Mot de passe *</span>
                <div className="inputContainerP">
                  <input
                    type={type}
                    placeholder={"**********************"}
                    value={pswd}
                    onChange={(e) => setpswd(e.target.value)}
                  />
                  {visible ? (
                    <VisibilityOutlined
                      className="icoPas"
                      onClick={() => {
                        setType("password");
                        setVisible(false);
                      }}
                    />
                  ) : (
                    <VisibilityOff
                      className="icoPas"
                      onClick={() => {
                        setType("text");
                        setVisible(true);
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
            {state.isLoading ? (
              <div className="btns">
                <button className="disabled">Annuler</button>
                <button className="waiting">
                  <LoaderIcon />
                  Enregistrement...
                </button>
              </div>
            ) : (
              <div className="btns">
                <button onClick={() => props.setOpen(false)}>Annuler</button>
                <button onClick={handleCreate}>Enregistrer</button>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default NewAccount;
